import { Translation } from '@ps/web-shared-components';

import ProgressiveKOIcon from '../../../assets/icons/game-type/progressive-ko.svg';
import TotalKOIcon from '../../../assets/icons/game-type/total-ko.svg';
import ZoomIcon from '../../../assets/icons/game-type/zoom.svg';
import type { IconsLegendData } from '../IconGroupLegend';
import IconGroupLegend from '../IconGroupLegend';

import {
  TXTCLI_Game_types,
  TXTCLI_Progressive_Knockout,
  TXTCLI_Total_Progressive_Knockout,
  TXTCLI_Zoom
} from './GameTypesIconLegend.messages.json';

const gameTypeConfig: IconsLegendData[] = [
  {
    Icon: <ZoomIcon />,
    Description: <Translation tagName="span" {...TXTCLI_Zoom} />
  },
  {
    Icon: <ProgressiveKOIcon />,
    Description: <Translation tagName="span" {...TXTCLI_Progressive_Knockout} />
  },
  {
    Icon: <TotalKOIcon />,
    Description: <Translation tagName="span" {...TXTCLI_Total_Progressive_Knockout} />
  }
];

const GameTypesIconLegend: React.FC = () => (
  <IconGroupLegend data={gameTypeConfig} title={<Translation {...TXTCLI_Game_types} />} />
);

export default GameTypesIconLegend;
